import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { classNames } from "../../utilities/props.js";
import Actionable from "../Actionable/index.js";
import s from "./Card.module.css";
import { resolveMixin } from "../../styles/mixin.js";
const Card = forwardRef((props, ref) => {
    const { padding = 4 } = props;
    const { selected, elevated, bleed, height, onClick, href, children, className, attributes, 
    // Using any here to let TS save on type resolving, otherwise TS throws an error due to the type complexity
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    as: TagName = "div", } = props;
    const isActionable = !!href || !!onClick;
    const mixinStyles = resolveMixin({
        radius: "medium",
        bleed,
        height,
        padding,
    });
    const rootClassNames = classNames(s.root, mixinStyles.classNames, isActionable && s["--actionable"], elevated && s["--elevated"], selected && s["--selected"], className);
    const style = {
        ...attributes?.style,
        ...mixinStyles.variables,
    };
    if (isActionable) {
        return (_jsx(Actionable, { className: rootClassNames, attributes: { ...attributes, style }, href: href, as: TagName, onClick: onClick, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ref: ref, children: children }));
    }
    return (_jsx(TagName, { ...attributes, onClick: onClick, href: href, ref: ref, className: rootClassNames, style: style, children: children }));
});
Card.displayName = "Card";
export default Card;
